function invertColor(x) {
    var t1 = '0123456789abcdef#', t2 = 'fedcba9876543210#';
    x = x.replace( /./gi, function (s) { return t2.charAt(t1.indexOf(s));} );
    return x;
}

const wsOrange = invertColor("#0d86d7"); //#f27928
const wsDarkGray = "#666666";

export const selected_color = wsOrange; //inverse of a nice blue
export const selected_attr = { fill: selected_color };

const thin_stroke = 1;
const medium_stroke = 2;

var med_arrow_stroke = 2;
var big_arrow_stroke = 5;

export const steel_shape_attr = {
    fill: "#A11500",
    stroke: wsDarkGray,
    'stroke-width': thin_stroke
};

// spans
export let steel_span_attr = {
    //gradient: '90-#A11500-#D14221', //steel
    'fill': '#D14221', // dark red
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

export let wood_span_attr = {
    'fill': '#F5DEB3', // wheat
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

export let custom_shape_span_attr = {
    'fill': '#1E90FF', // blue
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

export let result_span_attr = { 
    'stroke-width': medium_stroke,
}


//supports
export const support_attr = {
    gradient: '90-#636363-#999999',
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round'
};

export const free_support_attr = {
    gradient: '90-#636363-#999999',
    stroke: '#3b4449',
    'stroke-width': medium_stroke,
    'stroke-linejoin': 'round',
    opacity:0.4
};

//load arrow attributes
export const point_load_attr = {
    stroke: '#3b4449',
    'stroke-width': big_arrow_stroke
}

//
export const label_rect_attr = {
    fill : '#ffffff',
    'fill-opacity': 0.9,
    'stroke-linejoin': 'round'
}

//distributed loads
export const dist_load_arrow_attr = {
    stroke: '#3b4449',
    'stroke-width': med_arrow_stroke,
    'stroke-linejoin': 'round'
};

export const dist_load_rect_attr = {
    stroke: '#3b4449',
    'stroke-width': med_arrow_stroke,
    fill : '#FAE284',
    opacity:0.75
};
